const RichTextEditorStyles = `

.rich-text-editor {
    line-height: 18px;
    font-size: 12px;
}

.rich-text-editor h1,
.rich-text-editor h2,
.rich-text-editor h3,
.rich-text-editor h4,
.rich-text-editor h5,
.rich-text-editor h6 {
    font-weight: 700;
    margin-bottom: 10px;
    line-height: 1.5;
    letter-spacing: 0px;
    text-transform: none;
}

.rich-text-editor h1 {
    font-size: 14px;
}

.rich-text-editor h2 {
    font-size: 13px;
}

.rich-text-editor h3 {
    font-size: 12px;
}

.rich-text-editor h4 {
    font-size: 11px;
}

.rich-text-editor h5 {
    font-size: 10px;
}

.rich-text-editor h6 {
    font-size: 10px;
}

.rich-text-editor p {
    font-size: 12px;
    margin-bottom: 8px;
    line-height: 20px;
    padding: 0;
}

.rich-text-editor strong,
  .rich-text-editor b {
    font-weight: 700;
}

.rich-text-editor em {
    font-style: italic;
}

.rich-text-editor u {
    text-decoration: underline;
}

.rich-text-editor s {
    text-decoration: line-through;
}

.rich-text-editor blockquote {
    border-left: 4px solid #ccc;
    margin-bottom: 5px;
    margin-top: 5px;
    padding: 0px 0px 0px 15px;
}

.rich-text-editor ol {
    padding-left: 15px;
  margin-bottom: 8px;
}

.rich-text-editor ul {
    padding-left: 15px;
  margin-bottom: 5px;
}

.rich-text-editor li {
    padding: 0px 0px 0px 15px;
    line-height: 18px;
    margin: 0;
}

.rich-text-editor a {
    text-decoration: underline;
    color: inherit;
    font-weight: 400;
    font-size: 12px;
}

.rich-text-editor sup {
    vertical-align: super;
    font-size: 8px;
}

.rich-text-editor sub {
    vertical-align: sub;
    font-size: 8px;
}
.rich-text-editor .ql-size-small {
  font-size: 0.75em;
}
.rich-text-editor .ql-size-large {
  font-size: 1.5em;
}
.rich-text-editor .ql-size-huge {
  font-size: 2.5em;
}
.rich-text-editor ol > li,
.rich-text-editor ul > li {
  list-style-type: none;
}
.rich-text-editor ul > li::before {
  content: "\\2022";
}
.rich-text-editor ul[data-checked=true],
.rich-text-editor ul[data-checked=false] {
  pointer-events: none;
}
.rich-text-editor ul[data-checked=true] > li *,
.rich-text-editor ul[data-checked=false] > li * {
  pointer-events: all;
}
.rich-text-editor ul[data-checked=true] > li::before,
.rich-text-editor ul[data-checked=false] > li::before {
  color: #777;
  cursor: pointer;
  pointer-events: all;
}
.rich-text-editor ul[data-checked=true] > li::before {
  content: "\\2611";
}
.rich-text-editor ul[data-checked=false] > li::before {
  content: "\\2610";
}
.rich-text-editor li::before {
  display: inline-block;
  white-space: nowrap;
  width: 1.2em;
}
.rich-text-editor li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}
.rich-text-editor li.ql-direction-rtl::before {
  margin-left: 0.3em;
  margin-right: -1.5em;
}
.rich-text-editor ol li:not(.ql-direction-rtl),
.rich-text-editor ul li:not(.ql-direction-rtl) {
  padding-left: 1.5em;
}
.rich-text-editor ol li.ql-direction-rtl,
.rich-text-editor ul li.ql-direction-rtl {
  padding-right: 1.5em;
}
.rich-text-editor ol li {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0;
}
.rich-text-editor ol li:before {
  content: counter(list-0, decimal) '. ';
}
.rich-text-editor ol li.ql-indent-1 {
  counter-increment: list-1;
}
.rich-text-editor ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) '. ';
}
.rich-text-editor ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.rich-text-editor ol li.ql-indent-2 {
  counter-increment: list-2;
}
.rich-text-editor ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) '. ';
}
.rich-text-editor ol li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
.rich-text-editor ol li.ql-indent-3 {
  counter-increment: list-3;
}
.rich-text-editor ol li.ql-indent-3:before {
  content: counter(list-3, decimal) '. ';
}
.rich-text-editor ol li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}
.rich-text-editor ol li.ql-indent-4 {
  counter-increment: list-4;
}
.rich-text-editor ol li.ql-indent-4:before {
  content: counter(list-4, lower-alpha) '. ';
}
.rich-text-editor ol li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}
.rich-text-editor ol li.ql-indent-5 {
  counter-increment: list-5;
}
.rich-text-editor ol li.ql-indent-5:before {
  content: counter(list-5, lower-roman) '. ';
}
.rich-text-editor ol li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
}
.rich-text-editor ol li.ql-indent-6 {
  counter-increment: list-6;
}
.rich-text-editor ol li.ql-indent-6:before {
  content: counter(list-6, decimal) '. ';
}
.rich-text-editor ol li.ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
}
.rich-text-editor ol li.ql-indent-7 {
  counter-increment: list-7;
}
.rich-text-editor ol li.ql-indent-7:before {
  content: counter(list-7, lower-alpha) '. ';
}
.rich-text-editor ol li.ql-indent-7 {
  counter-reset: list-8 list-9;
}
.rich-text-editor ol li.ql-indent-8 {
  counter-increment: list-8;
}
.rich-text-editor ol li.ql-indent-8:before {
  content: counter(list-8, lower-roman) '. ';
}
.rich-text-editor ol li.ql-indent-8 {
  counter-reset: list-9;
}
.rich-text-editor ol li.ql-indent-9 {
  counter-increment: list-9;
}
.rich-text-editor ol li.ql-indent-9:before {
  content: counter(list-9, decimal) '. ';
}
.rich-text-editor .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 3em;
}
.rich-text-editor li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em;
}
.rich-text-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em;
}
.rich-text-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em;
}
.rich-text-editor .ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}
.rich-text-editor li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em;
}
.rich-text-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em;
}
.rich-text-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em;
}
.rich-text-editor .ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}
.rich-text-editor li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em;
}
.rich-text-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em;
}
.rich-text-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em;
}
.rich-text-editor .ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}
.rich-text-editor li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}
.rich-text-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em;
}
.rich-text-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em;
}
.rich-text-editor .ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}
.rich-text-editor li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em;
}
.rich-text-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em;
}
.rich-text-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em;
}
.rich-text-editor .ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}
.rich-text-editor li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em;
}
.rich-text-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em;
}
.rich-text-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em;
}
.rich-text-editor .ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}
.rich-text-editor li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em;
}
.rich-text-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em;
}
.rich-text-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em;
}
.rich-text-editor .ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}
.rich-text-editor li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em;
}
.rich-text-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em;
}
.rich-text-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em;
}
.rich-text-editor .ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em;
}
.rich-text-editor li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em;
}
.rich-text-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em;
}
.rich-text-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em;
}
.rich-text-editor .ql-video {
  display: block;
  max-width: 100%;
}
.rich-text-editor .ql-video.ql-align-center {
  margin: 0 auto;
}
.rich-text-editor .ql-video.ql-align-right {
  margin: 0 0 0 auto;
}
.rich-text-editor .ql-bg-black {
  background-color: #000;
}
.rich-text-editor .ql-bg-red {
  background-color: #e60000;
}
.rich-text-editor .ql-bg-orange {
  background-color: #f90;
}
.rich-text-editor .ql-bg-yellow {
  background-color: #ff0;
}
.rich-text-editor .ql-bg-green {
  background-color: #008a00;
}
.rich-text-editor .ql-bg-blue {
  background-color: #06c;
}
.rich-text-editor .ql-bg-purple {
  background-color: #93f;
}
.rich-text-editor .ql-color-white {
  color: #fff;
}
.rich-text-editor .ql-color-red {
  color: #e60000;
}
.rich-text-editor .ql-color-orange {
  color: #f90;
}
.rich-text-editor .ql-color-yellow {
  color: #ff0;
}
.rich-text-editor .ql-color-green {
  color: #008a00;
}
.rich-text-editor .ql-color-blue {
  color: #06c;
}
.rich-text-editor .ql-color-purple {
  color: #93f;
}
.rich-text-editor .ql-font-serif {
  font-family: Georgia, Times New Roman, serif;
}
.rich-text-editor .ql-font-monospace {
  font-family: Monaco, Courier New, monospace;
}
.rich-text-editor .ql-size-small {
  font-size: 0.75em;
}
.rich-text-editor .ql-size-large {
  font-size: 1.5em;
}
.rich-text-editor .ql-size-huge {
  font-size: 2.5em;
}
.rich-text-editor .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}
.rich-text-editor .ql-align-center {
  text-align: center;
}
.rich-text-editor .ql-align-justify {
  text-align: justify;
}
.rich-text-editor .ql-align-right {
  text-align: right;
}
.rich-text-editor.ql-blank::before {
  color: rgba(0,0,0,0.6);
  content: attr(data-placeholder);
  font-style: italic;
  left: 15px;
  pointer-events: none;
  position: absolute;
  right: 15px;
}
`;

export { RichTextEditorStyles };
